var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c("breadcrumb", { staticClass: "breadcrumb-container" }),
      _c("UpdatePassword", { ref: "updatePassword" }),
      _c("div", { staticClass: "right-menu" }, [
        _c("div", { staticClass: "avatar-container" }, [
          _c(
            "div",
            { staticClass: "avatar-wrapper" },
            [
              _c(
                "el-dropdown",
                { attrs: { trigger: "hover" } },
                [
                  _c("img", {
                    staticClass: "user-avatar",
                    attrs: { src: _vm.avatar },
                  }),
                  _c("div", { staticClass: "avatar-name" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "user-dropdown",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/" } },
                        [
                          _c("el-dropdown-item", [
                            _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("首页"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "router-link",
                        { attrs: { to: "/screen" } },
                        [
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("大屏页"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.updatePwd()
                            },
                          },
                        },
                        [
                          _c("span", { staticStyle: { display: "block" } }, [
                            _vm._v("修改密码"),
                          ]),
                        ]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.logout.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", { staticStyle: { display: "block" } }, [
                            _vm._v("退出"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }